import {MinMaxRateValue} from './min-max-rate-component.domain';

export type BusinessLoanRateCardValue = BusinessLoanRateCard | null;
export interface BusinessLoanRateCard {
  loanAmount: MinMaxRateValue,
  loanTerms: MinMaxRateValue,
  brokerage: MinMaxRateValue,
  adverseOnFile: number,
  docFee: MinMaxRateValue,
  // ZEN-818 follow-up: 3-tier model replaces base rate + (non-property / low-score / TIB) uplifts.
  // Tier membership is resolved by the calculator from property owner, Equifax director score
  // and GST (TIB) age inputs, so those uplifts are no longer stored on the rate card.
  tier1Rate: number,
  tier2Rate: number,
  tier3Rate: number,
}
